import { Component, OnInit } from '@angular/core';
import { faPercent } from '@fortawesome/free-solid-svg-icons';
import { DataSharingService } from '../../services/data-sharing/data-sharing.service';

@Component({
  selector: 'app-ride-beschaefigungsmerkmale',
  templateUrl: './ride-beschaefigungsmerkmale.component.html',
  styleUrls: ['./ride-beschaefigungsmerkmale.component.scss'],
})
export class RIDEBeschaefigungsmerkmaleComponent implements OnInit {
  faPercent = faPercent;
  public bArtList = [
    { value: 0, display: 'Verbeamtet' },
    { value: 1, display: 'Tarifbeschäftigt' },
    { value: 2, display: 'Arbeitnehmer*in' },
  ];
  public bundesl = [
    { value: 'bw', display: 'Baden-Württemberg' },
    { value: 'by', display: 'Bayern' },
    { value: 'beO', display: 'Berlin-Ost' },
    { value: 'be', display: 'Berlin' },
    { value: 'beW', display: 'Berlin-West' },
    { value: 'bb', display: 'Brandenburg' },
    { value: 'hb', display: 'Bremen' },
    { value: 'hh', display: 'Hamburg' },
    { value: 'he', display: 'Hessen' },
    { value: 'sl', display: 'Saarland' },
    { value: 'sn', display: 'Sachsen' },
    { value: 'st', display: 'Sachsen-Anhalt' },
    { value: 'sh', display: 'Schleswig-Holstein' },
    { value: 'th', display: 'Thüringen' },
    { value: 'mv', display: 'Mecklenburg-Vorpommern' },
    { value: 'ni', display: 'Niedersachsen' },
    { value: 'nw', display: 'Nordrhein-Westfalen' },
    { value: 'rp', display: 'Rheinland-Pfalz' },
  ];
  public JaNeinList = [
    { value: false, display: 'Nein' },
    { value: true, display: 'Ja' },
  ];
  stKList: number[] = [];
  anzahlKinderList = [0, 1, 2, 3, 4, 5];
  kinderList: number[] = [];
  public kvList = [
    { value: 'gkv', display: 'Gesetzlich' },
    { value: 'pvo', display: 'Privat ' },
  ];

  constructor(public dSS: DataSharingService) {}

  ngOnInit() {
    this.kinderList.push(0);
    for (let i = 0.5; i <= 6; i += 0.5) {
      this.kinderList.push(Number(i.toFixed(1)));
    }
    for (let i = 1; i <= 6; i += 1) {
      this.stKList.push(Number(i.toFixed(1)));
    }
  }

  update(changes: any, bArtChange = false): void {
    if (bArtChange) {
      this.dSS.inputChanged.next('bArt');
    } else {
      this.dSS.inputChanged.next(true);
    }
  }
}
